import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "confirm_blockly",
  class: "w-100",
  style: {"height":"300px"}
}, null, -1)
const _hoisted_2 = { class: "d-flex justify-content-between" }

import { onMounted, ref, withDefaults } from "vue";
import { GlobalImport } from "../../utils/GlobalImport";
import { DialogHandler } from "./DialogHandler";
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";
import { createToolbox } from "../../blockly/toolbox_v2";
import { blocklyStore } from "../../blockly/blocklyStore";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { useRouter } from "vue-router";
import { blocklyDispatcher } from "../../blockly/blocklyDispatcher";
import { VrockFileHandler } from "../../utils/VrockFileHandler";
import { translation } from "../../lang/Translation";
interface Prop {
  selectedItem: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RecoverBackupDialog',
  props: {
    selectedItem: { default: null }
  },
  setup(__props: any) {

const props = __props as { selectedItem: any };

const t = translation;



/**
 * 動的ラベル
 */
const backupRecoverRecovery = t.to("リカバリ", "recovery");

const Blockly = GlobalImport.getBlockly();
/**
 * プロパティ
 */
const pageTitle = t.to("リカバリ", "recovery");
const dialogId = DialogHandler.recoverBackupDialogId;
const router = useRouter();

const closeDialog = () => {
  DialogHandler.hideDialog(DialogHandler.recoverBackupDialogId);
};

/**
 * リカバリボタン
 */
const recoveryTitle = t.to("リカバリ", "recovery");
const selectedItem = ref(null as VrockFileHandler);
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, function () {
    selectedItem.value = DialogHandler.recoverItem;

    const toolBox = createToolbox();

    document.getElementById("confirm_blockly").innerHTML = "";
    toolBox.notify();
    // ワークスペースを構築
    const confirm_ws = Blockly.inject("confirm_blockly", {
      media: "/node_modules/scratch-blocks/media/",
      collapse: true,
      readOnly: true,
      zoom: {
        startScale: 0.5,
      },
    });
    const dom = Blockly.Xml.textToDom(selectedItem.value.block_xml);
    Blockly.Xml.domToWorkspace(dom, confirm_ws);
  });
});

const recovory = async () => {
  const isOK = await MessageDialog.confirm(
    t.to(
      "バックアップからリカバリします。リカバリすると現在のプロジェクトは上書きされます。よろしいですか？",
      "recovery_msg"
    )
  );
  if (!isOK) {
    return;
  }
  blocklyStore.project_id = selectedItem.value.project_id;
  blocklyStore.js_code = selectedItem.value.js_code;
  blocklyStore.title = "リカバリしたプロジェクト";

  // blocklyStore.workspace.clear();
  blocklyDispatcher.addMountedWorkspaceListener((workspace) => {
    workspace.cleanUp();
    // console.log(selectedItem.value.block_xml);
    const dom = Blockly.Xml.textToDom(selectedItem.value.block_xml);
    Blockly.Xml.domToWorkspace(dom, workspace);
    blocklyStore.save().then();
  });
  router.push(`/blockly/${blocklyStore.project_id}`);
  DialogHandler.hideDialog(dialogId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-lg': true },
    title: _unref(pageTitle)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-danger me-2",
          onClick: recovory
        }, _toDisplayString(_unref(backupRecoverRecovery)), 1),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: closeDialog
        }, "閉じる")
      ]),
      _createTextVNode(" " + _toDisplayString(props))
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})